<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<fe-header style="z-index: 1000"></fe-header>
<main>
    <router-outlet></router-outlet>
</main>
<fe-footer></fe-footer>
